import { OrderProduct, GoProduct } from "../constant/products";
import { ACT_ORDER, ACT_GO } from "../constant/act_stat";


export default {
    orderTime:state=>{
        return state.actInfo&&state.actInfo.progress ==ACT_ORDER
    },
    goTime:state=>{
        return state.actInfo&&state.actInfo.progress ==ACT_GO
    }
    ,
	// product:state=>{
    //     console.log("getters ACT_GO?",state.actInfo&&state.actInfo.progress ==ACT_GO)
    //     let product = state.actInfo&&state.actInfo.progress ==ACT_GO?GoProduct:OrderProduct
    //     console.log("product",product)        
    //     return product
    // }
}


// WEBPACK FOOTER //
// ./src/store/getters.js